<template>
	<QwoachDialogLayout>
		<div >

			<InvoiceDetails v-if="invoiceItem" :invoice="invoiceItem"/>
			<div v-if="invoiceItem" class="mb-4"><a :href="invoiceItem.detailsUrl" target="_blank" @click="seeInvoiceClicked">See invoice</a></div>

			<p class="small text-muted" v-if="canRemovePaidMark(invoiceItem)">Didn't receive the payment? Click the "remove paid mark" button below</p>
		</div>
		<template #footer>
			<div class="row dialog-footer mx-0" style="text-align: left" >
				<el-button size="small" plain type="danger" @click="removePaidMark"
					v-if="canRemovePaidMark(invoiceItem)">Remove "paid" mark</el-button>
				<div class="layout-spacer"></div>
				<el-button size="small" type="primary" @click="onCancel">Close</el-button>
			</div>
		</template>
	</QwoachDialogLayout>
</template>

<script>

	import BillingItem from "@shared/Billing/BillingItem";
	import {InvoiceCommand} from "@shared/Invoice/InvoiceItem";

	import InvoiceDetails from "@/core/components/InvoiceDetails.vue"
	import InvoiceGroup from "@shared/Invoice/InvoiceGroup";
	import {PaymentMethod} from "@shared/Invoice/InvoiceItem";
	import QwoachDialog from "@/core/components/Dialogs/QwoachDialog/QwoachDialog.vue";
	import QwoachDialogLayout from "@/core/components/Dialogs/QwoachDialog/QwoachDialogLayout.vue";


	export default {
        name: "PaymentConfirmedDialog",
		extends: QwoachDialog,
		components: {
			QwoachDialogLayout,
			InvoiceDetails
		},

		props:{
			billingItem: BillingItem,
			invoiceGroup: InvoiceGroup
		},
		data: () => ({
			paidDate: new Date(),
			command: InvoiceCommand.OK,
			invoiceItem: null
		}),

		created(){
			this.invoiceItem = this.invoiceGroup.generalInvoice()
		},
		methods:{

			onYes(){
				this.closeConfirm()
			},
			createDataItem(){
				return {
					command: this.command,
				}
			},
			removePaidMark(){
				this.command = InvoiceCommand.REMOVE_PAID
				this.onAction("actionRemovePaidMark")
			},
			canRemovePaidMark(invoiceItem){
				return invoiceItem.paidWith == PaymentMethod.NONE ||
					invoiceItem.paidWith == PaymentMethod.MANUAL
			},

			seeInvoiceClicked(){
				this.$analyticManager.trackEvent("See invoice clicked", this.analyticsPropsMethod())
			}

		},


		computed:{
        	dialogTitle(){
        		return "Payment details"
			}
		}


    }
</script>
